import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PageButton from "./PageButton";
var Pagination = /*#__PURE__*/function (_PureComponent) {
  _inherits(Pagination, _PureComponent);
  var _super = _createSuper(Pagination);
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getVisiblePages", function (page, total) {
      var zeroBasedTotal = total - 1;
      if (zeroBasedTotal < 7) {
        return Array.from({
          length: total
        }, function (value, index) {
          return index;
        });
      }
      if (page > 3 && page + 3 < zeroBasedTotal) {
        return [0, page - 1, page, page + 1, zeroBasedTotal];
      }
      if (page > 3 && page + 3 >= zeroBasedTotal) {
        return [0, zeroBasedTotal - 4, zeroBasedTotal - 3, zeroBasedTotal - 2, zeroBasedTotal - 1, zeroBasedTotal];
      }
      return [0, 1, 2, 3, 4, zeroBasedTotal];
    });
    var pages = props.pages,
      _page = props.page;
    _this.state = {
      visiblePages: _this.getVisiblePages(_page, pages)
    };
    _this.changePage = _this.changePage.bind(_assertThisInitialized(_this));
    _this.previousPage = _this.previousPage.bind(_assertThisInitialized(_this));
    _this.nextPage = _this.nextPage.bind(_assertThisInitialized(_this));
    _this.getVisiblePages = _this.getVisiblePages.bind(_assertThisInitialized(_this));
    _this.setVisiblePages = _this.setVisiblePages.bind(_assertThisInitialized(_this));
    _this.checkEllipsis = _this.checkEllipsis.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
        currentPages = _this$props.pages,
        triggerOnPropChange = _this$props.triggerOnPropChange;
      var nextPages = nextProps.pages,
        page = nextProps.page;
      if (currentPages !== nextPages) {
        this.setState({
          visiblePages: this.getVisiblePages(page, nextPages)
        });
        if (triggerOnPropChange) {
          this.changePage(page + 1);
        }
      }
    }
  }, {
    key: "setVisiblePages",
    value: function setVisiblePages(clickedPage) {
      var pages = this.props.pages;
      var visiblePages = this.getVisiblePages(clickedPage, pages);
      this.setState({
        visiblePages: visiblePages
      });
    }
  }, {
    key: "changePage",
    value: function changePage(clickedPage) {
      var _this$props2 = this.props,
        onPageChange = _this$props2.onPageChange,
        page = _this$props2.page;
      if (clickedPage === page) {
        return;
      }
      this.setVisiblePages(clickedPage);
      onPageChange(clickedPage);
    }
  }, {
    key: "previousPage",
    value: function previousPage() {
      var page = this.props.page;
      var previousPageNumber = page - 1;
      if (previousPageNumber < 0) {
        return;
      }
      this.changePage(previousPageNumber);
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      var _this$props3 = this.props,
        page = _this$props3.page,
        pages = _this$props3.pages;
      var nextPageNumber = page + 1;
      if (nextPageNumber >= pages) {
        return;
      }
      this.changePage(nextPageNumber);
    }
  }, {
    key: "checkEllipsis",
    value: function checkEllipsis(pageNumber, index, array) {
      return index === 0 ? false : pageNumber - array[index - 1] > 1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        t = _this$props4.t,
        page = _this$props4.page,
        pages = _this$props4.pages,
        previousBtnText = _this$props4.previousBtnText,
        nextBtnText = _this$props4.nextBtnText;
      var visiblePages = this.state.visiblePages;
      if (pages <= 1 || visiblePages === null) {
        return null;
      }
      return /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
        className: "pagination pull-right"
      }, /*#__PURE__*/React.createElement("li", {
        className: page === 0 ? 'disabled' : null
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.previousPage
      }, " ", previousBtnText)), visiblePages.map(function (pageNumber, index, array) {
        var addEllipsis = _this2.checkEllipsis(pageNumber, index, array);
        return /*#__PURE__*/React.createElement(PageButton, {
          key: pageNumber,
          pageNumber: pageNumber,
          activePage: page,
          changePage: _this2.changePage,
          addEllipsis: addEllipsis
        });
      }), /*#__PURE__*/React.createElement("li", {
        className: page + 1 === pages ? 'disabled' : null
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.nextPage
      }, " ", nextBtnText))));
    }
  }]);
  return Pagination;
}(PureComponent);
Pagination.defaultProps = {
  triggerOnPropChange: true
};
Pagination.propTypes = {
  pages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  previousBtnText: PropTypes.string.isRequired,
  nextBtnText: PropTypes.string.isRequired,
  onPageChange: PropTypes.func.isRequired,
  triggerOnPropChange: PropTypes.bool
};
export default Pagination;